<template>
  <b-field :label="title">
              <b-autocomplete
                  :data="data"
                  placeholder="e.g. Project Management"
                  :loading="isFetching"
                  @typing="getAsyncData"
                  @select="option => selected = option">
                  <template slot-scope="props">
                      <div class="media">
                          <div class="media-content">
                              <b class="has-text-primary">{{ props.option.name }}</b>
                              <br>
                              <small>
                                  <b>{{ props.option.meta_products_total_count }}</b> products
                                  <br />
                                  <b>{{ props.option.meta_chunks_total_count | numeral('0.a') }}</b> feedbacks analysed
                              </small>
                          </div>
                      </div>
                  </template>
              </b-autocomplete>
          </b-field>
</template>

<script>
    import debounce from 'lodash/debounce'

    export default {
      name: "FindProductDropdown",
        data() {
            return {
                data: [],
                selected: null,
                isFetching: false
            }
        },
        props: ["title"],
        methods: {
            // You have to install and import debounce to use it,
            // it's not mandatory though.
            getAsyncData: debounce(function (name) {
                if (!name.length) {
                    this.data = []
                    return
                }
                this.isFetching = true
                this.$http.get(`${this.$root.api_base_url}categories/?ordering=-meta_chunks_total_count&search=${name}`)
                    .then(({ data }) => {
                        this.data = []
                        data.results.forEach((item) => this.data.push(item))
                    })
                    .catch((error) => {
                        this.data = []
                        throw error
                    })
                    .finally(() => {
                        this.isFetching = false
                    })
            }, 100)
        }
    }
</script>
